module.exports = __webpack_public_path__ + "img/user.dce7ce04.png";